require('./bootstrap');
require('./components/jquery.playSound');

// Imports
import $ from 'jquery';
window.$ = window.jQuery = $;

import 'lazysizes';
import 'lazysizes/plugins/unveilhooks/ls.unveilhooks';

window.Swiper = require('swiper/swiper-bundle');
window.jscroll = require('jscroll');

require('flatpickr');
require('flatpickr/dist/l10n/pl').default.pl;

import SimpleLightbox from "simplelightbox";
window.SimpleLightbox = SimpleLightbox;

window.moment = require('moment');
window.moment.locale('pl')

import Sortable, { MultiDrag, Swap } from 'sortablejs';
window.Sortable = Sortable;

require('dropzone');
Dropzone.autoDiscover = false;

require('./core');
